import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CardPreview from '../common/CardPreview';
const ContactCard = () => {
    return (_jsx(CardPreview, { icon: "faEnvelope", description: "Start a conversation or reach out directly.", title: _jsxs(_Fragment, { children: [_jsx("span", { className: "text-text-primary", children: "Get" }), '\u00A0', _jsx("span", { className: "text-text-accent", children: "In" }), '\u00A0', _jsx("span", { className: "text-text-accent", children: "Touch" })] }) }));
};
export default ContactCard;
